import * as React from 'react';
import { useSettingsContext } from '../contexts/settings';
import ListItem from './cards/ListItem';

const PostsList = ({ posts, setLoadingHeight }) => {
	const listRef = React.useRef(false);
	const settings = useSettingsContext();

	React.useEffect(() => {
		if (listRef?.current?.offsetHeight) {
			setLoadingHeight(`${listRef.current.offsetHeight}px`);
		} else {
			setLoadingHeight(null);
		}
	}, [posts]);

	if (posts.length) {
		return (
			<div ref={listRef} className={`pfa-posts-list pfa-posts-list--${settings.postType}`}>
				{posts.map((post) => (
					<ListItem post={post} key={post.ID} />
				))}
			</div>
		);
	}
};

PostsList.displayName = 'PostsList';

export default PostsList;
